'use strict';

export default function buildSubscriptionCategory (category) {
    return [
        `<div class="form-group m-b">`,
            `<div class="col-sm-offset-3 col-sm-9 p-l-xxs xs-p-l">`,
                `<label for="subscribe${category.name}" class="control-label control-label-checkbox">`,
                    `<span class="checkbox-button form-control-dark">`,
                        `<input name="categories[]" value="${category.id}" id="subscribe${category.name}" type="checkbox" class="checkbox-hidden"${category.subscribed ? ' checked="checked"' : ''}>`,
                        `<span class="glyphicon glyphicon-ok" aria-hidden="true"></span>`,
                    `</span>`,
                    `<span class="checkbox-text">${category.name}</span>`,
                `</label>`,
            `</div>`,
        `</div>`
    ].join('');
}
